// V1.5+ Slice 2 — Cut Link tuning per docs/02_GAME_DESIGN.md §13 / §15 / §16.
//
// Cut Link is the Recon's E (secondary) ability: a short channel at an
// enemy-or-neutral relay that, if uninterrupted, severs that relay's signal
// links for a window. The cut node stops conducting through SignalLinkSystem's
// BFS, so downstream owned relays drop to isolated and any forward
// (`mini_turret`) anchored on them goes offline (Slice 1's `isOnline`
// pipeline takes over from there).
//
// Calibration:
//   - The Recon must be within `CUT_LINK_TARGET_RANGE_PX` of the relay to
//     start the channel (relay capture radius is 120 px, Recon vision 700 px;
//     220 px gives the Recon a clear "I'm at this relay" footprint without
//     letting it tap a relay from outside its own visible band).
//   - The channel takes `CUT_LINK_CHANNEL_SEC` seconds. Long enough that the
//     defender has a real reaction window (counterplay per §13: shoot the
//     Recon, push it off the relay) but short enough that a Recon that
//     successfully reaches the relay doesn't have to stand exposed forever.
//   - The cut lasts `CUT_LINK_DURATION_SEC` seconds. Long enough that the
//     downstream pressure collapse is real (forward turret goes dark, isolated
//     income kicks in) but short enough that a single cut isn't game-ending.
//   - Cooldown `CUT_LINK_COOLDOWN_SEC` is longer than Mark Target's 30 s — a
//     Recon can either paint a target OR cut a link in any 45-second window.
//
// Per Rule 17 (anti-turtling) and Rule 18 (felt on the battlefield), the
// values are tuned so the strategic dynamic §14 calls out emerges:
//   "I cut his mid relay. His forward turret nest goes dark, and his
//    south relay drops to isolated income. Now I can push the south."
export const CUT_LINK_TARGET_RANGE_PX = 220;
export const CUT_LINK_TARGET_RANGE_SQ = CUT_LINK_TARGET_RANGE_PX * CUT_LINK_TARGET_RANGE_PX;
export const CUT_LINK_CHANNEL_SEC = 3;
export const CUT_LINK_DURATION_SEC = 30;
export const CUT_LINK_COOLDOWN_SEC = 45;
